import React, { useEffect, useRef, useState, useContext } from "react";
import {
    Grid,
    TextField,
    Typography,
    Paper,
    Switch,
    FormControlLabel,
    Container,
    Box,
} from "@mui/material";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import Textarea from "@mui/joy/Textarea";
import "leaflet/dist/leaflet.css";
import LocationMarker from "../../ui/Map";
import Dropdown from "../../ui/Dropdown";
import { ImageIcon, VideoIcon, ImageUp, MonitorUp } from "lucide-react";
import { Mutation, useMutation, useMutationState } from "@tanstack/react-query";
import { postCarData, useFetchData, postDeveloperData, postDeveloperedit, postDeveloperEdit } from "../../hooks/useFetchData";
import { useTranslation } from "react-i18next";
import Modall from "../../ui/Modal";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { redirect, useNavigate, useParams } from "react-router-dom";
import { formdeveloperSchemaa, formSchemaa, validationSchema } from "../../component/validation";

import "react-loading-skeleton/dist/skeleton.css";
import CustomerTestimonial from "../../ui/Loading";
import { ToastContainer, toast } from "react-toastify";
import L, { setOptions } from "leaflet";
import customIconUrl from '../Cars/images/car.png'; // Replace with your actual image path
import { usecontextUser } from "../../context/usecontextUser";


let DefaultIcon = L.icon({
    iconUrl: customIconUrl,
    // shadowUrl: iconShadow,
    iconSize: [60, 60],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    // shadowSize: [41, 41],
});
export default function Developer() {
    const [hasExistingImage, setHasExistingImage] = useState(false);
    const { user } = useContext(usecontextUser)
    const { id } = useParams()
    L.Marker.prototype.options.icon = DefaultIcon;

    const { data: data2 } = useFetchData(
        `https://3dfinal.tanaghomtech.com/public/api/developers/${id}`
    );


    const { t } = useTranslation();
    const navigate = useNavigate();


    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();
    const [preview, setPreview] = useState(null);
    const [formDataa, setFormDataa] = useState({});
    const [open, setOpen] = useState();

    const fileInputRef = useRef();
    console.log("ffff", preview);

    const {
        register,
        handleSubmit,
        formState: { errors },
        trigger,
        getValues,
        setValue,
    } = useForm({
        resolver: yupResolver(formdeveloperSchemaa),
    });
    useEffect(() => {
        if (data2?.data) {
            setValue("developer_name", data2.data.developer_name);
            setValue("developer_name_en", data2.data.developer_name_en);
            setValue("developer_address", data2.data.developer_address);
            setValue("developer_address_en", data2.data.developer_address_en);
            setValue("developer_description", data2.data.developer_description);
            setValue("developer_description_en", data2.data.developer_description_en);
            setValue("developer_email", data2.data.developer_email);
            setValue("developer_phone", data2.data.developer_phone);
            if (data2.data.developer_image) {
                setPreview(data2.data.developer_image);
                setHasExistingImage(true); // ✅ نعلم أن هناك صورة موجودة بالفعل
            }
        }
    }, [data2]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (value !== undefined) {
            setFormDataa((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };


    const mutation = useMutation({
        mutationFn: id ? (formData) => postDeveloperEdit(formData, id) : postDeveloperData,
        onSuccess: (data) => {
            console.log("Full API Response:", data);
            id && navigate("/management")
            const postReference = data?.data?.post_reference; // Or adjust this based on your API response
            if (postReference) {
                console.log("Posted successfully", postReference);
                setData(postReference);
            } else {
                console.error("Response data structure is not as expected:", data);
            }
        },
        onError: (error) => {
            console.error("Posting failed", error.message);
        },
    });

    const handleOpen = async () => {
        const valid = await trigger([
            "developer_name",
            "developer_name_en",
            "developer_address",
            "developer_address_en",
            "developer_description",
            "developer_email",
            "developer_phone",

        ]);
        if (valid) {
            setOpen(true);
        } else {
            toast.error("complete all required input");
        }
    };

    const handleSubmitAction = async (data) => {
        console.log("📦 Raw data:", data);
        setOpen(false);
        setLoading(true);
        const formValues = getValues();
        try {
            await formdeveloperSchemaa.validate(formValues, { abortEarly: false });
            console.log("✅ Valid data:", formValues);
            const formData = new FormData();
            // ✅ أضف باقي الحقول باستثناء developer_image
            Object.entries(formValues).forEach(([key, value]) => {
                if (key !== "developer_image") {
                    formData.append(key, value ?? "");
                }
            });
            // ✅ معالجة صورة جديدة فقط
            const image = formValues.developer_image;
            if (image instanceof File) {
                formData.append("developer_image", image);
            }
            formData.append("_method", "PUT");
            if (!id) {
                setLoading(false);
                toast.error("No ID provided for developer");
                return;
            }
            console.log("📦 Sending formData to API with ID:", id);
            mutation.mutate(formData);
        } catch (validationError) {
            setLoading(false);
            console.error("❌ Validation errors:", validationError.errors);
            toast.error("Validation failed! Please check the input.");
        }
    };
    return (
        <form onSubmit={handleSubmit(handleSubmitAction)}>
            {loading ? (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "100px",
                    }}
                >
                    <CustomerTestimonial />
                </div>
            ) : (
                <Container sx={{ overflowY: "auto", mb: 10 }}>
                    <Paper
                        elevation={10}
                        style={{
                            backgroundColor: "#fff",
                            padding: 0,
                            borderRadius: 16,
                            marginTop: 16,
                            direction: t("directions.dir"),
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                mt: 2,
                                mb: 2,
                                boxShadow:
                                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                                padding: "8px",
                                backgroundColor: "#f3efee",
                                display: "inline-block",
                                width: "auto",
                                fontWeight: "bold",
                                fontFamily: "oswald,cairo",
                                //   right:'0',
                                //   position:'absolute'
                            }}
                        >
                            {t("AddCar.Step1")}
                        </Typography>
                        <div style={{ padding: "24px" }}>
                            <Box
                                sx={{
                                    width: "100%",
                                    gap: 2,
                                    maxWidth: "100%",
                                    display: "flex",
                                    mb: 3,
                                }}
                            >
                                <TextField
                                    fullWidth
                                    {...register("developer_name")}
                                    name="developer_name"
                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddCar.developer_name")}

                                            <span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>
                                        </span>
                                    }
                                    InputLabelProps={{ shrink: true }}
                                    error={!!errors.developer_name}
                                    helperText={errors.developer_name?.message}
                                />
                                <TextField
                                    {...register("developer_name_en")}
                                    fullWidth
                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddCar.developer_name_en")}{" "}
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>
                                        </span>
                                    }
                                    InputLabelProps={{ shrink: true }}
                                    id="fullWidth"
                                    name="developer_name_en"
                                    error={!!errors.developer_name_en}
                                    helperText={errors.developer_name_en?.message}
                                />
                            </Box>
                            <Box
                                sx={{
                                    width: "100%",
                                    gap: 2,
                                    maxWidth: "100%",
                                    display: "flex",
                                    mb: 3,
                                }}
                            >
                                <TextField
                                    fullWidth
                                    {...register("developer_address")}
                                    id="fullWidth"
                                    name="developer_address"
                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddCar.address")}{" "}
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>
                                        </span>
                                    }
                                    InputLabelProps={{ shrink: true }}
                                    error={!!errors.developer_address}
                                    helperText={errors.developer_address?.message}
                                />
                                <TextField
                                    fullWidth
                                    {...register("developer_address_en")}
                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddCar.address_en")}{" "}
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>
                                        </span>
                                    }
                                    InputLabelProps={{ shrink: true }}
                                    id="fullWidth"
                                    name="developer_address_en"
                                    error={!!errors.developer_address_en}
                                    helperText={errors.developer_address_en?.message}
                                />
                            </Box>
                            <Box sx={{ mb: 2 }}>
                                <label
                                    htmlFor="description"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        fontWeight: "400",
                                        color: "gray",
                                    }}
                                >
                                    {t("AddCar.description")}{" "}
                                    {<span
                                        style={{
                                            color: "red",
                                            fontSize: "25px",
                                            marginBottom: "-5px",
                                        }}
                                    >
                                        *
                                    </span>} I
                                </label>
                                <Textarea
                                    id="developer_description"
                                    name="developer_description"
                                    minRows={4}
                                    size="lg"
                                    {...register("developer_description")}
                                    error={!!errors.developer_description}
                                />
                                {errors.developer_description && (
                                    <Typography variant="caption" color="error">
                                        {errors.developer_description.message}
                                    </Typography>
                                )}
                                <Box sx={6}></Box>
                            </Box>
                            <Box sx={12}>
                                <label style={{ fontWeight: "400", color: "gray" }}>
                                    {t("AddCar.description_en")}
                                </label>
                                <Textarea
                                    xs={5}
                                    minRows={4}
                                    {...register("developer_description_en")}
                                    size="lg"
                                    label="developer_description_en"
                                    name="developer_description_en"
                                    value={formDataa.developer_description_en || data2?.data?.developer_description_en}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                                <p>{errors.developer_description_en?.message}</p>
                                <Box sx={6}></Box>
                            </Box>
                        </div>
                    </Paper>
                    <Paper
                        elevation={10}
                        style={{
                            padding: 0,
                            borderRadius: 16,
                            marginTop: 16,
                            display: "flex",
                        }}
                    >
                        <Box
                            sx={{
                                width: "100%",
                                gap: 2,
                                maxWidth: "100%",
                                mb: 3,
                                direction: t("directions.dir"),

                            }}
                        >
                            <Typography
                                variant="h4"
                                sx={{
                                    mt: 2,
                                    mb: 2,
                                    boxShadow:
                                        "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                                    padding: "8px",
                                    backgroundColor: "#f3efee",
                                    display: "inline-block",
                                    width: "auto",
                                    fontWeight: "bold",
                                    fontFamily: "oswald,cairo",
                                    //   right:'0',
                                    //   position:'absolute'
                                }}
                            >
                                {t("AddCar.Step3")}
                            </Typography>
                            <Box
                                sx={{

                                    gap: 2,
                                    maxWidth: "100%",
                                    display: "flex",
                                    mb: 3,
                                    margin: "20px"
                                }}
                            >
                                <TextField
                                    fullWidth
                                    {...register("developer_email")}
                                    id="fullWidth"
                                    name="developer_email"

                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddCar.developer_email")}{" "}
                                            {<span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>}
                                        </span>
                                    }
                                    InputLabelProps={{ shrink: true }}
                                    error={!!errors.developer_email}
                                    helperText={errors.developer_email?.message}
                                />
                                <TextField
                                    fullWidth
                                    {...register("developer_website")}

                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddCar.developer_website")}{" "}
                                            {<span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>}
                                        </span>
                                    }
                                    InputLabelProps={{ shrink: true }}
                                    id="fullWidth"
                                    name="developer_website"
                                />
                                <TextField
                                    fullWidth
                                    {...register("developer_phone")}

                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddCar.developer_phone")}{" "}
                                            {<span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>}
                                        </span>
                                    }
                                    InputLabelProps={{ shrink: true }}
                                    id="fullWidth"
                                    name="developer_phone"
                                    error={!!errors.developer_phone}
                                    helperText={errors.developer_phone?.message}
                                />
                            </Box>
                        </Box>
                    </Paper>
                    <Paper
                        elevation={10}
                        style={{
                            padding: 0,
                            borderRadius: 16,
                            marginTop: 16,
                            direction: t("directions.dir"),
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                mt: 2,
                                mb: 2,
                                boxShadow:
                                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                                padding: "8px",
                                backgroundColor: "#f3efee",
                                display: "inline-block",
                                width: "auto",
                                fontWeight: "bold",
                                fontFamily: "oswald,cairo",
                                //   right:'0',
                                //   position:'absolute'
                            }}
                        >
                            {t("AddCar.mainimage")}{" "}
                            <span
                                style={{ color: "red", fontSize: "25px", marginBottom: "-5px" }}
                            >
                                *
                            </span>
                        </Typography>

                        <Box
                            component="label"
                            sx={{
                                width: 250,
                                height: 180,
                                border: "1px solid #ddd",
                                borderRadius: 2,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                backgroundColor: "#fff",
                                overflow: "hidden",
                            }}
                        >
                            {preview ? (
                                <img
                                    src={
                                         preview.includes("http://localhost:3000")
                                            ? preview
                                            : `https://3dfinal.tanaghomtech.com/storage/app/public/${preview}`
                                    }
                                    alt="Preview"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            ) : (
                                <ImageUp size={64} color="black" />
                            )}

                            {!hasExistingImage &&
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    ref={fileInputRef}
                                    {...register("developer_image", {
                                        required: "Image is required",
                                    })}
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setValue("developer_image", file, { shouldValidate: true });
                                            setPreview(URL.createObjectURL(file));
                                            setHasExistingImage(true);
                                        }
                                    }}
                                />
                            }

                            {hasExistingImage &&
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    ref={fileInputRef}
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setValue("developer_image", file, { shouldValidate: true });
                                            setPreview(URL.createObjectURL(file));
                                            setHasExistingImage(true);
                                        }
                                    }}
                                />
                            }


                        </Box>

                        {errors["developer_image"] && (
                            <Typography variant="h5" color="error">
                                {errors["developer_image"].message}
                            </Typography>
                        )}

                        <Grid container>
                            <Grid size={10}></Grid>
                            <Grid size={2}>
                                <Modall
                                    handleOpen={handleOpen}
                                    open={open}
                                    setOpen={setOpen}
                                    handle={handleSubmitAction}
                                    loading={loading}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Container>
            )}
        </form>
    );
}
